import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CreditsModalPage } from './credits-modal';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		CreditsModalPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(CreditsModalPage),
	],
})
export class CreditsModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/credits-modal/credits-modal.module.ts